import { useContext } from "react";
import {
  SetupGuideContext,
  type SetupGuideContextValue,
} from "./setup-guide-context";

/**
 * Consumer hook for setup guide state + mutators. Throws when used
 * outside <SetupGuideProvider> OR when the feature flag is off (in which
 * case the provider intentionally doesn't render its inner value).
 *
 * Components that may render outside the flag-gated subtree should use
 * `useSetupGuideOptional` instead.
 */
export function useSetupGuide(): SetupGuideContextValue {
  const value = useContext(SetupGuideContext);
  if (!value) {
    throw new Error(
      "useSetupGuide() called outside SetupGuideProvider (or with feature flag disabled)",
    );
  }
  return value;
}

/** Soft variant — returns null when the provider isn't active. */
export function useSetupGuideOptional(): SetupGuideContextValue | null {
  return useContext(SetupGuideContext);
}
